import { useContext } from "react";
import State from "../../../../../../context";
import ModalSettingsFeeTaxInflation from "../../../super_admin/page/PageCompanies/component/SectionCompanyOne/component/ModalSettingsFeeTaxInflation";
import ModalSettingsLogo from "../../../super_admin/page/PageCompanies/component/SectionCompanyOne/component/ModalSettingsLogo";
import ModalSettingsTheme from "../../../super_admin/page/PageCompanies/component/SectionCompanyOne/component/ModalSettingsTheme";
import ModalSettingsVideo from "../../../super_admin/page/PageCompanies/component/SectionCompanyOne/component/ModalSettingsVideo";
import SectionCompanySettings from "../../../super_admin/page/PageCompanies/component/SectionCompanyOne/component/SectionCompanySettings";

import StyledContainer from "./style";

import {
  updateCompanySettingsByJwt,
  uploadCompanyLogoByJwt,
} from "../../request";

const PageSettings = () => {
  const [state] = useContext(State);

  const onClickUpdateLogo = () => {
    state.setKeyValue("openModalLogo", true);
  };

  const onClickUpdateTheme = () => {
    state.setKeyValue("openModalTheme", true);
  };

  const onClickUpdateVideo = () => {
    state.setKeyValue("openModalDashboardVideo", true);
  };

  const onClickUpdateFeesTaxesInflation = () => {
    state.setKeyValue("openModalFeeTaxInflation", true);
  };

  const toggleDashboardVideo = isEnabled => {
    submitSettings({
      video: {
        ...state.settings?.video,
        enabled: isEnabled,
      },
    });
  };

  const toggleFeature = name => {
    const typeExistInDB = !!state?.settings?.features?.find(
      it => it.name === name
    );

    const updatedFeatures = typeExistInDB
      ? state?.settings?.features?.map(it => {
          if (it.name === name) {
            return {
              name,
              enabled: !it.enabled,
            };
          } else {
            return it;
          }
        })
      : [
          ...state?.settings?.features,
          {
            name,
            enabled: true,
          },
        ];

    submitSettings({
      features: updatedFeatures,
    });
  };

  const toggleFeesTaxesInflation = isEnabled => {
    submitSettings({
      financialFactors: {
        ...state.settings?.financialFactors,
        enabled: isEnabled,
      },
    });
  };

  const toggleTheme = isEnabled => {
    submitSettings({
      theme: {
        ...state.settings?.theme,
        enabled: isEnabled,
      },
    });
  };

  const submitDashboardVideo = ({ videoUrl }) => {
    submitSettings({
      video: {
        ...state.settings?.video,
        url: videoUrl,
      },
    });
  };

  const submitFeesTaxesInflation = values => {
    submitSettings({
      financialFactors: {
        ...state.settings?.financialFactors,
        data: values,
      },
    });
  };

  const submitLogo = fileData => {
    if (!fileData?.file?.fileList) return;

    state.setKeyValue("loading", true);

    const formData = new FormData();
    formData.append("file", fileData.file.fileList[0].originFileObj);

    uploadCompanyLogoByJwt({
      requestPayload: formData,
      userEmail: state._id,
    })
      .then(response => {
        state.setKeyValue("settings", response.settings);
        state.showSuccess("Company Logo Updated.");
        state.setKeyValue("openModalLogo", false);
      })
      .catch(state.showError)
      .finally(() => state.setKeyValue("loading", false));
  };

  const submitSettings = requestPayload => {
    state.setKeyValue("loading", true);

    updateCompanySettingsByJwt({
      userEmail: state._id,
      requestPayload,
    })
      .then(response => {
        state.setKeyValue("settings", response.settings);
        state.showSuccess("Settings updated!");
        state.setKeyValue("openModalDashboardVideo", false);
      })
      .catch(state.showError)
      .finally(() => state.setKeyValue("loading", false));
  };

  const submitTheme = data => {
    submitSettings({
      theme: {
        ...state.settings?.theme,
        data,
      },
    });
  };

  return (
    <StyledContainer>
      <header>Settings</header>

      <SectionCompanySettings
        onClickUpdateFeesTaxesInflation={onClickUpdateFeesTaxesInflation}
        onClickUpdateLogo={onClickUpdateLogo}
        onClickUpdateTheme={onClickUpdateTheme}
        onClickUpdateVideo={onClickUpdateVideo}
        settings={state?.settings}
        showSectionFeesTaxesInflation
        toggleDashboardVideo={toggleDashboardVideo}
        toggleFeature={toggleFeature}
        toggleFeesTaxesInflation={toggleFeesTaxesInflation}
        toggleTheme={toggleTheme}
      />

      <ModalSettingsFeeTaxInflation
        defaultState={state.settings?.financialFactors?.data}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalFeeTaxInflation", false)}
        onSuccess={submitFeesTaxesInflation}
        open={state.openModalFeeTaxInflation}
      />
      <ModalSettingsLogo
        activeLogoUrl={state.settings?.logo?.url}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalLogo", false)}
        onSuccess={submitLogo}
        open={state.openModalLogo}
      />
      <ModalSettingsTheme
        activeThemeId={state.settings?.theme?.data?.id}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalTheme", false)}
        onSuccess={submitTheme}
        open={state.openModalTheme}
      />
      <ModalSettingsVideo
        activeVideoUrl={state?.settings?.video?.url}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalDashboardVideo", false)}
        onSuccess={submitDashboardVideo}
        open={state.openModalDashboardVideo}
      />
    </StyledContainer>
  );
};

export default PageSettings;
